import React from 'react';
import { Body, Button, Flex } from '@cognite/cogs.js';
import { DrawerSteps } from 'components/DrawerSteps/DrawerSteps';
import { DrawerWithTitle } from '../components/Schemas/ViewSchemaPage/ProjectRuleset/components/DrawerWithTitle';
import { DigitalTwin } from 'types/graphql-apollo-v2';
import {
  ConsistencyCollectionView,
  ConsistencyRuleView,
  ConsistencySchemaFilterView,
} from './types';
import { useNewConsistencyRuleDrawer } from './useNewConsistencyRuleDrawer';
import { buildRuleSteps } from './NewConsistencyRuleDrawer.steps';

type NewConsistencyRuleDrawerProps = {
  visible: boolean;
  onClose: VoidFunction;
  collection: ConsistencyCollectionView | null;
  schemaFilters: ConsistencySchemaFilterView[];
  digitalTwin: DigitalTwin;
  initialRule?: ConsistencyRuleView;
};

export const NewConsistencyRuleDrawer = (
  props: NewConsistencyRuleDrawerProps
) => {
  const hookResult = useNewConsistencyRuleDrawer(props);
  const {
    currentStep,
    setCurrentStep,
    creating,
    hasInvalidValues,
    onCreateRule,
    onCancelHandler,
  } = hookResult;

  const steps = buildRuleSteps({
    ...hookResult,
    schemaFilters: props.schemaFilters,
  });

  return (
    <DrawerWithTitle
      footer={
        <Flex justifyContent="flex-end" alignItems="center" gap={8}>
          <Button onClick={onCancelHandler}>Cancel</Button>
          <Button
            type="primary"
            onClick={onCreateRule}
            loading={creating}
            disabled={creating || hasInvalidValues}
          >
            Create comparison rule
          </Button>
        </Flex>
      }
      onCancel={onCancelHandler}
      selectedMilestoneName={props.collection?.name}
      subHeader={
        <Body size="medium">
          Define a comparison rule to check consistency between schema filters
        </Body>
      }
      title="Create comparison rule"
      visible={props.visible}
    >
      <DrawerSteps
        steps={steps}
        currentStep={currentStep}
        onChangeStep={(step: number) => setCurrentStep(step)}
      />
    </DrawerWithTitle>
  );
};
